import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { DeviceDetectorState } from './device-detector.state';
import { NativeAppType } from '../../types/device-types';

export const deviceDetectorActions = createActionGroup({
  source: 'Device Detector',
  events: {
    Initialized: emptyProps(),

    Detected: props<{ detectedDevice: Partial<DeviceDetectorState> }>(),
    SetNativeAppType: props<{ nativeAppType: NativeAppType }>(),
  },
});
